import React from 'react';
import { useSelector } from 'react-redux';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

import ContainerBox from 'components/ContainerBox';
import OrderRow from './OrderRow';
import { useTranslation } from 'services/localization/useTranslation';
import { OrderInfo } from 'common/types';
import * as ShopSelectors from 'selectors/ShopSelectors';

interface Props {
	orders: OrderInfo[];
	cancelOrderList: string[];
	handleRowCheckbox: (orderId: string) => void;
}

const OrdersList = ({ orders, handleRowCheckbox, cancelOrderList }: Props) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const shopCurrency = useSelector(ShopSelectors.getShopCurrency);

	return (
		<ContainerBox className={classes.containerBox}>
			<TableContainer>
				<Table>
					<TableHead className={classes.tableHead}>
						<TableRow>
							<TableCell></TableCell>
							<TableCell>{t('orders.orderId', 'Order ID')}</TableCell>
							<TableCell>{t('orders.activationDate', 'Activation date')}</TableCell>
							<TableCell>{t('orders.status', 'Status')}</TableCell>
							<TableCell>{t('orders.customer', 'Customer')}</TableCell>
							<TableCell>{t('orders.payment', 'Payment')}</TableCell>
							<TableCell align="right" className={classes.lastCell}>{`${t(
								'orders.totalValue',
								'Total value',
							)} (${shopCurrency.displayAs})`}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{orders.map((row) => (
							<OrderRow
								key={row.id}
								order={row}
								handleRowCheckbox={handleRowCheckbox}
								isChecked={cancelOrderList.includes(row.id)}
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</ContainerBox>
	);
};

const useStyles = makeStyles((theme) =>
	createStyles({
		tableHead: {
			whiteSpace: 'nowrap',
		},
		containerBox: {
			boxShadow: `0 1px 3px 0 rgba(0, 0, 0, 0.31)`,
			padding: theme.spacing(2, 0),
		},
		firstCell: {
			paddingLeft: theme.spacing(5),
		},
		lastCell: {
			paddingRight: theme.spacing(5),
		},
	}),
);

export default OrdersList;
